export default {
  state: {
    activeCourt: '',
    applyCourtData: {},
    // 选择申请人模板页面数据
    selectTemplateForm: {},
    listParams: {},
    // 所属人
    owner: {
      pltUnit: '',
      pltLeaderName: '',
    },
  },
  mutations: {
    SAVE_APPLY_COURT_DATA: (state, _data) => {
      state.applyCourtData = _data;
    },
    SAVE_ACTIVE_COUNT: (state, _data) => {
      state.activeCourt = _data;
    },
    SAVE_SELECT_TEMPLATE_FORM: (state, _data) => {
      state.selectTemplateForm = JSON.parse(JSON.stringify(_data));
    },
    SAVE_LIST_PARAMS: (state, _data) => {
      state.listParams = _data;
    },
    SAVE_OWNER:  (state, _data) => {
      state.owner[_data.key] = _data.value;
    },
    CLEAR_OWNER:  (state, _data) => {
      Object.keys(state.owner).map(key => {
        state.owner[key] = '';
      });
    },
  },
  actions: {
    SaveApplyCourtData({commit}, _data) {
      commit('SAVE_APPLY_COURT_DATA', _data);
    },
    // 保存法院
    SaveActiveCount({commit}, _data) {
      commit('SAVE_ACTIVE_COUNT', _data);
    },
    // 保存申请人模板
    SaveSelectTemplateForm({commit}, _data) {
      commit('SAVE_SELECT_TEMPLATE_FORM', _data);
    },
    // 保存申请人模板
    SaveListParams({commit}, _data) {
      commit('SAVE_LIST_PARAMS', _data);
    },
    SaveOwner({commit}, _data) {
      commit('SAVE_OWNER', _data);
    },
    ClearOwner({commit}) {
      commit('CLEAR_OWNER');
    },
  }
};
